//@flow
export const ENTITY_NAME_ID = 'masterTeam';
export const ENTITY_EXPORT_ID = 'TEAM_MASTER';
export const ENTITY_TABLE_ID = 'TeamMaster';
export const ENTITY_TYPE = 'Team';
